<template>
  <v-container fluid>
    <v-row>
      <v-col
        v-if="loading"
        v-for="i in 3"
        :key="i"
        cols="12"
        sm="4"
        md="4"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="article"
        />
      </v-col>
      <v-col
        cols="12"
        sm="4"
        md="4"
        v-for="item in items" 
        :key="item.id"
      >
        <v-card
          class="mx-auto rounded-lg"
          outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 no-break-w">
                {{item.tengoi}}
              </v-list-item-title>
              <v-list-item-subtitle v-html="item.dien_thoai"/>
              <v-list-item-subtitle v-html="item.branch.name"/>
            </v-list-item-content>
            <v-list-item-avatar
              tile
              size="80"
            >
              <v-img src="@/assets/support.png"/>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions class="justify-center">
            <v-btn
              text
              color="primary"
              rounded
              :to="{ name: 'SupportView', params: { id: item.id }}"
            >
              <v-icon class="mr-2">
                mdi-mailbox-up
              </v-icon>
              Hộp thư
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    data: () => ({
      loading: false,
      items: [],
    }),
    mounted () {
      this.initialize();
    },
    methods: {
      initialize () {
        this.loading = true;
        axios.get("api/v1/public/experts")
          .then(response => {
            this.items = response.data;
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>
<style>
  .no-break-w {
    white-space: normal;
  }
</style>